/** IMD棚卸集計表/検索指示 */
export const SEARCH_INVENTORY_SUMMARYS_API_CONSTANT = {
  // レポート種別
  RKIND: 'rkind',
  // 検索項目
  VALUE: 'value',
};
